import { render, staticRenderFns } from "./addEducatingPeople.vue?vue&type=template&id=001cf011&scoped=true"
import script from "./addEducatingPeople.vue?vue&type=script&lang=js"
export * from "./addEducatingPeople.vue?vue&type=script&lang=js"
import style0 from "./addEducatingPeople.vue?vue&type=style&index=0&id=001cf011&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001cf011",
  null
  
)

export default component.exports